(function () {
  if (window.__barryInit) return;
  window.__barryInit = true;

  function reveal(scope) {
    var els = scope.querySelectorAll('.by-reveal:not(.by-in)');
    if (!('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('by-in'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('by-in'); io.unobserve(e.target); }
      });
    }, { threshold: 0.15 });
    els.forEach(function (el) { io.observe(el); });
  }

  function fit(scope) {
    scope.querySelectorAll('[data-by-fit]').forEach(function (root) {
      if (root.__byFit) return;
      root.__byFit = true;
      var answers = {};
      var result = root.querySelector('[data-fit-result]');
      root.querySelectorAll('.by-fit__opts').forEach(function (group) {
        group.addEventListener('click', function (e) {
          var btn = e.target.closest('button');
          if (!btn) return;
          group.querySelectorAll('button').forEach(function (b) { b.classList.remove('by-on'); });
          btn.classList.add('by-on');
          answers[group.dataset.q] = btn.dataset.v;
          if (answers.hitch && answers.barrow) show();
        });
      });
      function show() {
        var key = answers.hitch === 'no' ? 'nohitch'
          : answers.barrow === 'yes' ? 'square'
          : answers.barrow === 'unsure' ? 'unsure' : 'ok';
        var tpl = root.querySelector('[data-fit-msg="' + key + '"]');
        if (tpl && result) {
          result.innerHTML = tpl.innerHTML;
          result.classList.add('by-show');
        }
      }
    });
  }

  function gallery(scope) {
    scope.querySelectorAll('[data-by-gallery]').forEach(function (root) {
      if (root.__byGal) return;
      root.__byGal = true;
      var track = root.querySelector('.by-gallery__track');
      var count = root.querySelector('[data-count]');
      var prev = root.querySelector('[data-prev]');
      var next = root.querySelector('[data-next]');
      if (!track) return;
      var slides = track.children.length;
      var i = 0;
      function update() { if (count) count.textContent = (i + 1) + ' / ' + slides; }
      function go(n) {
        i = (n + slides) % slides;
        track.scrollTo({ left: track.clientWidth * i, behavior: 'smooth' });
        update();
      }
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });
      track.addEventListener('scroll', function () {
        var n = Math.round(track.scrollLeft / track.clientWidth);
        if (n !== i) { i = n; update(); }
      }, { passive: true });
      update();
    });
  }

  function init(scope) { var s = scope || document; reveal(s); fit(s); gallery(s); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
